import React from 'react';

import styles from './KeyStats.module.scss';

const KeyStats = (props) => (
    <div className={`${styles.KeyStats}${props.className ? ` ${props.className}` : '' }`} style={ props.style } id={ props.id }>
        {
            !props.blank &&
            <h2>Key Stats</h2>
        }
        <div className={styles.KeyStats__wrapper}>
            {props.keystats.map((stat, i) =>
                <div className="keystat" key={i}>
                  <h3 className="h3">{stat.title}</h3>
                  <p>{stat.text.text}</p>
                </div>
            )}
        </div>
    </div>
)

export default KeyStats;



// WEBPACK FOOTER //
// ./src/components/SuccessStories/KeyStats/index.js